<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("heading.packages") }}</v-toolbar-title>
      <v-spacer />
      <v-btn :to="{ name: 'create-package' }" large class="primary">
        <v-icon left>mdi-plus</v-icon>
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>

    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="packages"
      resName="packages"
      class="table-row"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="text-sm-center">{{ item.duration_in_nights }}</td>
        <td class="text-sm-center">{{ item.max_person_price }}</td>
        <td class="text-sm-center">{{ item.max_person_price }}</td>

        <td class="text-sm-center">{{ item.return_pct }}</td>
        <td class="text-sm-center">{{ item.reserve_before_start_in_hours }}</td>

        <td class="text-sm-center">
          <v-btn
            class="info"
            :to="{ name: 'package-option-groups', params: { slug: item.slug } }"
          >
            <span>{{ $t("fields.option_gorups") }}</span>
          </v-btn>
        </td>
        <td class="text-sm-center">
          <v-btn
            class="info"
            :to="{ name: 'daily-programs', params: { slug: item.slug } }"
          >
            <span>{{ $t("fields.daily_programs") }}</span>
          </v-btn>
        </td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="packages"
            :model-id="item.id"
            field="allow_custom_dates"
            v-model="item.allow_custom_dates"
            :validate="true"
          />
        </td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="packages"
            :model-id="item.id"
            field="auto_accept_order"
            v-model="item.auto_accept_order"
            :validate="true"
          />
        </td>

        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="packages"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>

        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="packages"
            :model-id="item.id"
            field="available"
            v-model="item.available"
            :validate="true"
          />
        </td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="packages"
            :model-id="item.id"
            field="premium"
            v-model="item.premium"
            :validate="true"
          />
        </td>

        <td class="text-sm-center">
          <v-btn
            icon
            color="info"
            :to="{ name: 'edit-package', params: { slug: item.slug } }"
          >
            <v-icon :title="$t('icon.edit')" small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon
              color="error"
              @click="handleDelete(item, index)"
              :title="$t('icon.delete')"
              small
              >mdi-delete</v-icon
            >
          </v-btn>
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
  </main>
</template>

<script>
export default {
  name: "Packages",
  data() {
    return {
      headers: [
        "name",
        "nights_count",
        "max_person_price",
        "min_person_price",
        "return_pct",
        "reservation_before_start_by",
        "option_groups",
        "daily_programs",
        "allow_custom_dates",
        "auto_accept_order",
        "visible",
        "available",
        "premium",
        "actions"
      ]
    };
  },
  methods: {
    handleDelete({ slug }, index) {
      this.$refs.table_ref.handleDelete(slug, index);
    }
  }
};
</script>
